type DialogFocusControl = HTMLButtonElement | HTMLSelectElement;

export class DialogFocus {
  private active = false;

  public constructor(
    private readonly documentScope: Document,
    private readonly initialControl: DialogFocusControl,
    private readonly controls: readonly DialogFocusControl[],
    private readonly restoreControl: DialogFocusControl,
  ) {}

  public activate(): void {
    if (this.active) {
      return;
    }
    this.active = true;
    this.documentScope.addEventListener("keydown", this.handleKeydown);
    this.initialControl.focus();
  }

  public deactivate(): void {
    if (!this.active) {
      return;
    }
    this.active = false;
    this.documentScope.removeEventListener("keydown", this.handleKeydown);
    this.restoreControl.focus();
  }

  public destroy(): void {
    this.deactivate();
  }

  private readonly handleKeydown = (event: KeyboardEvent): void => {
    if (event.key !== "Tab") {
      return;
    }
    const controls = this.controls.filter(
      (control) => !control.disabled && !control.hidden,
    );
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (first === undefined || last === undefined) {
      return;
    }
    const activeIndex = controls.findIndex(
      (control) => control === this.documentScope.activeElement,
    );
    const wrapsBackward = event.shiftKey && activeIndex <= 0;
    const wrapsForward = !event.shiftKey && activeIndex === controls.length - 1;
    const recoversFocus = activeIndex === -1;
    if (!wrapsBackward && !wrapsForward && !recoversFocus) {
      return;
    }
    event.preventDefault();
    if (event.shiftKey) {
      last.focus();
    } else {
      first.focus();
    }
  };
}
